import Box from '@material-ui/core/Box';
import CardMedia from '@material-ui/core/CardMedia';
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import LinearProgress from '@material-ui/core/LinearProgress';
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import Astronaut from "../images/astronaut.svg";
import { getProgressMilestone } from "../redux/actions/dataActions";


const styles = {
  root: {
    minWidth: "275px",
  },
  center: {
    margin: "auto 1em auto 1em",
    minWidth: "275px",
  },
  containerCentral: {
    justifyContent: "center",
  },
  lightText: {
    fontWeight: "100",
  },
  media: {
    width: "auto",
    height: 350,
    position:"relative",
    margin: "-5px 0px 0px -200px",
  },
};

const normalize = value => (value - 0 ) * 100 / 75;

const findBuffer = value => {
  if (value< 25 ) return 25; 
  else if (value< 50) return 50;
  else return 75;
}; 

const getCurrentStatus = value => {
  if (value < 25 ) return "Good job on your work so far! "; 
  else if (value < 50) return "Good job on completing Level 1: Novice Explorer!";
  else if (value < 75) return "Good job on completing Level 2: Deep Dive!";
  else return "Congrats on completing the course";
}; 

const getNextStatus = value => {
  if (value < 25 ) 
    return "Accumulate " + (25-value) + " more points to finish Level 1: Novice Explorer!"; 
  else if (value < 50) 
    return "Accumulate " + (50-value) + " more points to finish Level 2: Deep Dive!";
  else if (value < 75) 
    return "Accumulate " + (75-value) + " more points to finish Level 3: All Star!";
  else return "Hope you enjoyed our course!";
}; 

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="buffer" value={normalize(props.value)} valueBuffer={normalize(props.bufferValue)} />
        <Box width="100%" style={{position:"relative"}}>
          <Typography style={{left:"33%", position:"absolute", transform:"translateX(-100%)"}} align="center">Level 1</Typography>
          <Typography style={{left:"66%", position:"absolute", transform:"translateX(-100%)"}} align="center">Level 2</Typography> 
          <Typography style={{left:"100%", position:"absolute", transform:"translateX(-100%)"}} align="center" display="inline" noWrap={true}>Level 3</Typography> 
        </Box>
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value,
        )}`}</Typography>
      </Box>
    </Box>
  );
}

export class milestone extends Component {
  componentDidMount() {
    this.props.getProgressMilestone();
  }

  render() {
    const { classes } = this.props;
    const { milestone, loading } = this.props.data; 

    let milestoneLayout; 

    if (loading) {
      milestoneLayout = (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </div>
      );
    } else {

      let progressValue = 0; 
      let name = "Explorer";
  
      if (Object.keys(milestone).length != 0) {
        progressValue = parseInt(milestone[0].score); 
        name = milestone[0].name; 
      }
  
      let bufferValue = findBuffer(progressValue);
      let currentStatus = getCurrentStatus(progressValue);
      let nextStatus = getNextStatus(progressValue);
  
      milestoneLayout = (
        <div className={classes.root}>
          <LinearProgressWithLabel value={progressValue} bufferValue={bufferValue} />
          <br/>
          <br/>
          <Typography variant="h5"> {currentStatus} {nextStatus} </Typography>
          <Typography variant="h5"> Kaya mo yan explorer!  </Typography>
          <br/>
          <CardMedia 
            className={classes.media} 
            image={Astronaut}
          /> 
        </div>
      );
    }

    return (
      <Grid container className={classes.containerCentral}>
        <Grid item sm />
        <Grid item sm className={classes.center}>
          <Typography variant="h3">Progress Milestone</Typography>
          <Typography variant="h5">Hi Explorer, here is your progress:</Typography>
          <br/>
          {milestoneLayout}
        </Grid>
        <Grid item sm />
      </Grid>
    );
  }
}

milestone.propTypes = {
  getProgressMilestone: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps, { getProgressMilestone })(
  withStyles(styles)(milestone)
);